//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AllTasksPage from "@/components/tasks/myTeamsTasks/allTasksComponent.vue";

export default {
    name: "AppTasksContainer",
    components: {
        AllTasksPage
    },
    beforeRouteUpdate(to, from, next) {
        if (this.dropdownIsOpen) {
            this.updateTaskList = true;
        }
        next();
    },
    props: {
        type: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            showSearch: false,
            search: null,
            fromFabricInt: false,
            selectedTab: "toDoTasksTab",
            showTaskInstance: true,
            resetFilters: false,
            tasksType: "myOpenTasks",
            currentPage: "myOpenTasks",
            pageTabs: {
                toDoTasksTab: "todo",
                completedTasksTab: "completed"
            },
            dropdownIsOpen: false,
            updateTaskList: false,
            afterCreated: true
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("main", ["getFromMyTeamsTasksMenu"]),
        searchValue: {
            get() {
                return this.search || this.currentApp.name;
            },
            set(v) {
                this.search = v;
            }
        },
        getType() {
            let type = "myOpenTasks";
            if (this.selectedTab === "toDoTasksTab") {
                type = this.getFromMyTeamsTasksMenu ? "teamsTasks" : "myOpenTasks";
            } else {
                type = this.getFromMyTeamsTasksMenu ? "completedTeamsTasks" : "completedTasks";
            }
            return type;
        },
        getSelectedTabType() {
            return this.pageTabs[this.selectedTab];
        },
        checkIfTeams() {
            const { name } = this.$route;
            return name === "teamsTasks";
        }
    },
    watch: {
        getFromMyTeamsTasksMenu() {
            if (!this.fromFabricInt) {
                this.selectedTab = "toDoTasksTab";
            }
            this.fromFabricInt = false;
        },
        type: {
            handler() {
                this.showTaskInstance = true;
            }
        },
        $route: {
            handler(newValue) {
                const { name, query } = newValue || {};
                if (["teamsTasks", "myOpenTasks"].includes(name) && (this.currentPage !== name || (query.tab && query.tab !== this.getSelectedTabType))) {
                    this.currentPage = name;
                    this.$store.commit("main/setFromMyTeamsTasksMenu", name === "teamsTasks");
                    this.resetFilters = true;
                    this.$nextTick(() => {
                        this.resetFilters = false;
                        this.tasksType = this.getType;
                    });
                    if (query) {
                        this.selectedTab = query.tab === "todo" ? "toDoTasksTab" : "completedTasksTab";
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        const { name, query } = this.$route;

        this.$store.commit("main/setFromMyTeamsTasksMenu", name === "teamsTasks");

        if (Object.keys(query).length) {
            this.selectedTab = query.tab === "completed" ? "completedTasksTab" : "toDoTasksTab";
            this.tasksType = this.getType;
        }
    },
    activated() {
        const { query } = this.$route;
        if (this.afterCreated) {
            this.afterCreated = false;
        } else if (Object.keys(query).length) {
            this.selectedTab = query.tab === "completed" ? "completedTasksTab" : "toDoTasksTab";
            this.tasksType = this.getType;
        }
        this.showTaskInstance = true;
    },
    deactivated() {
        this.showTaskInstance = false;
    },
    methods: {
        changeTab() {
            this.resetFilters = true;
            this.$nextTick(() => {
                this.resetFilters = false;
                this.tasksType = this.getType;
            });
        },
        checkIfDropdownOpened(data) {
            this.dropdownIsOpen = data;
        }
    }

};
